/**
 * AutoMazen - Video + Features Section
 * Intersection Observer for autoplay and play/pause controls
 * For Bioethanol Fires website
 */

document.addEventListener('DOMContentLoaded', function() {
  // Handle all video wrappers, not just autoplay
  const videoWrappers = document.querySelectorAll('.am-video-features__video-wrapper');
  
  videoWrappers.forEach(videoWrapper => {
    const video = videoWrapper.querySelector('.am-video-features__video');
    
    if (!video) return;
    
    // Add error handling for video loading
    video.addEventListener('error', function(e) {
      console.error('🎥 Video loading error:', e);
      console.error('Video source:', video.querySelector('source')?.src);
    });
    
    video.addEventListener('loadeddata', function() {
      console.log('🎥 Video loaded successfully');
    });
    
    // Force video to load
    video.load();
    
    // Check if this is an autoplay video
    const isAutoplay = videoWrapper.getAttribute('data-video-autoplay') === 'true';
    
    if (!isAutoplay) {
      // For non-autoplay videos with controls, just ensure they're ready
      console.log('🎥 Video with controls loaded and ready');
      return;
    }
    
    // Handle autoplay videos below
    const playToggle = videoWrapper.querySelector('.am-video-features__play-toggle');
    const playIcon = videoWrapper.querySelector('.am-video-features__play-icon');
    const pauseIcon = videoWrapper.querySelector('.am-video-features__pause-icon');

    // Update button icons
    function updatePlayButton(showPlay) {
      if (playIcon && pauseIcon) {
        if (showPlay) {
          playIcon.style.display = 'block';
          pauseIcon.style.display = 'none';
        } else {
          playIcon.style.display = 'none';
          pauseIcon.style.display = 'block';
        }
      }
    }

    // Intersection Observer for autoplay
    const observerOptions = {
      threshold: 0.5, // Play when 50% visible
      rootMargin: '0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          video.play().catch(err => {
            console.log('Autoplay prevented:', err);
          });
          updatePlayButton(false); // Show pause icon
        } else {
          video.pause();
          updatePlayButton(true); // Show play icon
        }
      });
    }, observerOptions);

    observer.observe(videoWrapper);

    // Play/Pause toggle button
    if (playToggle) {
      playToggle.addEventListener('click', function() {
        if (video.paused) {
          video.play();
          updatePlayButton(false);
        } else {
          video.pause();
          updatePlayButton(true);
        }
      });
    }

    // Update button on video play/pause events
    video.addEventListener('play', function() {
      updatePlayButton(false);
    });

    video.addEventListener('pause', function() {
      updatePlayButton(true);
    });
  }); // Close forEach
});
